/* api/index */ function _(require, module, exports) {
    var tslib_1 = require(426) /* tslib */;
    var LinAlg = require(430) /* ./linalg */;
    exports.LinAlg = LinAlg;
    var Charts = require(427) /* ./charts */;
    exports.Charts = Charts;
    var Plotting = require(434) /* ./plotting */;
    exports.Plotting = Plotting;
    var document_1 = require(54) /* ../document */;
    exports.Document = document_1.Document;
    var templating_1 = require(42) /* ../core/util/templating */;
    exports.sprintf = templating_1.sprintf;
    tslib_1.__exportStar(require(432) /* ./models */, exports);
}
